export default "__VITE_ASSET__0db2513a__"